// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.meetingPage_graphicSpeed{
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    padding: 28px 12px;

    border: 1px solid #CAC4D0;
    box-shadow: 0px 4px 12px -3.76017px rgba(8, 8, 10, 0.15);
    border-radius: 17.2052px;

    width: 100%;
    height: 100%;
}

.meetingPage_graphicSpeed_title{
    font-weight: 600;
    font-size: 26px;
    line-height: 35px;
    text-align: center;

    color: #000000;
}

.meetingPage_graphicSpeed_text{
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    text-align: center;

    color: #000000;
    opacity: 0.5;
}

.meetingPage_graphicSpeed_bottom{
    display: flex;
    justify-content: space-between;
    width: 100%;
}

.meetingPage_graphicSpeed_bottom_a{
    font-weight: 400;
    font-size: 7px;
    line-height: 10px;
    color: #000000;
    opacity: 0.5;
}

.meetingPage_graphicSpeed_bottom_b{
    font-weight: 700;
    font-size: 7px;
    line-height: 10px;
    text-align: right;

    color: #000000;
    opacity: 0.9;
}
`, "",{"version":3,"sources":["webpack://./src/pages/meetingPage/MeetingPageGraphicSpeed.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;;IAElB,yBAAyB;IACzB,wDAAwD;IACxD,wBAAwB;;IAExB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;;IAElB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;;IAElB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,iBAAiB;;IAEjB,cAAc;IACd,YAAY;AAChB","sourcesContent":[".meetingPage_graphicSpeed{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n    padding: 28px 12px;\n\n    border: 1px solid #CAC4D0;\n    box-shadow: 0px 4px 12px -3.76017px rgba(8, 8, 10, 0.15);\n    border-radius: 17.2052px;\n\n    width: 100%;\n    height: 100%;\n}\n\n.meetingPage_graphicSpeed_title{\n    font-weight: 600;\n    font-size: 26px;\n    line-height: 35px;\n    text-align: center;\n\n    color: #000000;\n}\n\n.meetingPage_graphicSpeed_text{\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 16px;\n    text-align: center;\n\n    color: #000000;\n    opacity: 0.5;\n}\n\n.meetingPage_graphicSpeed_bottom{\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n}\n\n.meetingPage_graphicSpeed_bottom_a{\n    font-weight: 400;\n    font-size: 7px;\n    line-height: 10px;\n    color: #000000;\n    opacity: 0.5;\n}\n\n.meetingPage_graphicSpeed_bottom_b{\n    font-weight: 700;\n    font-size: 7px;\n    line-height: 10px;\n    text-align: right;\n\n    color: #000000;\n    opacity: 0.9;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
